var objectToString = Object.prototype.toString

module.exports = objectToString



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticObjectToString.js
// module id = TdHP
// module chunks = 137